/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S5_HeadingInputs */

const tr_cerez_s5_heading = /** @type {(inputs: Cerez_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Üçüncü Taraflar`)
};

const en_cerez_s5_heading = /** @type {(inputs: Cerez_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Third parties`)
};

const de_cerez_s5_heading = /** @type {(inputs: Cerez_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Dritte`)
};

const ru_cerez_s5_heading = /** @type {(inputs: Cerez_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Третьи лица`)
};

/**
* | output |
* | --- |
* | "5. Third parties" |
*
* @param {Cerez_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s5_heading = /** @type {((inputs?: Cerez_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s5_heading(inputs)
	if (locale === "de") return de_cerez_s5_heading(inputs)
	if (locale === "ru") return ru_cerez_s5_heading(inputs)
	return tr_cerez_s5_heading(inputs)
});